const query = (id, isPreview) => `
{
  socialLinks(id: "${id}", preview: ${isPreview}) {
    internalTitle
    linkCollection{
      items{
        title
        url
        ariaLabel
        images{
          altText
          imageMobile {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          imageDesktop {
            title
            description
            contentType
            fileName
            size
            url
            width
            height
          }
          
        }
      }
    }
  }
}


`
module.exports = { query }
